import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const SETTINGS_PANE_ROW_CLASS_NAME = 'SettingsPaneRow';
export const SETTINGS_PANE_ROW_CLASS_SLOTS = ['root'] as const;

export type SettingsPaneRowClassSlot =
	(typeof SETTINGS_PANE_ROW_CLASS_SLOTS)[number];

export interface SettingsPaneRowClasses {
	root: string;
}

export type SettingsPaneRowClassKey = keyof SettingsPaneRowClasses;

export const getSettingsPaneRowUtilityClass = (slot: string) =>
	generateUtilityClass(SETTINGS_PANE_ROW_CLASS_NAME, slot);

export const settingsPaneRowClasses = generateUtilityClasses<
	keyof SettingsPaneRowClasses
>(SETTINGS_PANE_ROW_CLASS_NAME, ['root']);
export default settingsPaneRowClasses;
